export const COMMON_AREA = 'commonAreas';
export const MAINTENANCE_AREA = 'maintenanceAreas';
export const COMMON_AREA_NAME = 'COMMON_AREA';
export const MAINTENANCE_AREA_NAME = 'STAFF_ONLY';
